module.exports = __webpack_public_path__ + "img/menu_active_bg.db9391f.png";